import React from 'react'
import { OrganizationListProps } from '../types'
import { OrganizationItem } from './OrganizationItem'
import { Stack, ListItem, ListSubheader, Divider } from '@mui/material'

export const OrganizationList: React.FC<OrganizationListProps> = ({
    organizations,
    isDarkMode,
    onOrganizationSelect,
}) => {
    if (organizations.length === 0) {
        return <ListItem className="no-organizations">No organizations found</ListItem>
    }

    const favoriteOrgs = organizations.filter((org) => org.isFavorite)
    const regularOrgs = organizations.filter((org) => !org.isFavorite)

    return (
        <>
            {/* Favorites section */}
            {favoriteOrgs.length > 0 && (
                <Stack className="org-section">
                    <ListItem
                        className="section-header "
                        sx={{
                            backgroundColor: 'figma.grayscale.contentWrapper',
                            padding: '0',
                        }}
                    >
                        <ListSubheader
                            sx={{
                                backgroundColor: 'figma.grayscale.contentWrapper',
                                fontSize: 'inherit',
                                color: 'inherit',
                                padding: '0',
                                width: '100%',
                            }}
                        >
                            Pinned
                            <Divider />
                        </ListSubheader>
                    </ListItem>
                    {favoriteOrgs.map((org) => (
                        <OrganizationItem
                            key={org._id}
                            organization={org}
                            isDarkMode={isDarkMode}
                            isFavorite={org.isFavorite}
                            onSelect={onOrganizationSelect}
                        />
                    ))}
                </Stack>
            )}

            {/* Regular organizations section */}
            {regularOrgs.length > 0 && (
                <Stack className="org-section">
                    <ListItem
                        className="section-header organizations-header"
                        sx={{ backgroundColor: 'figma.grayscale.contentWrapper', paddingLeft: '0', paddingBottom: '0' }}
                    >
                        <ListSubheader
                            sx={{
                                backgroundColor: 'inherit',
                                color: 'figma.grayscale.textHier1',
                                fontSize: 'inherit',
                                padding: '0',
                                width: '100%',
                            }}
                        >
                            More Organizations
                            <Divider sx={{ position: 'sticky' }} />
                        </ListSubheader>
                    </ListItem>
                    {regularOrgs.map((org) => (
                        <>
                            <OrganizationItem
                                key={org._id}
                                organization={org}
                                isDarkMode={isDarkMode}
                                onSelect={onOrganizationSelect}
                            />
                        </>
                    ))}
                </Stack>
            )}
        </>
    )
}
